import { $t } from '@/i18n';
import { ApprovalOperation } from '@/services/flow';
const getFlowSchema = () => ({
    id: 'flow',
    title: $t('k_4af63156'),
    type: 'object',
    readonly: true,
    'uc:collapsed': true,
    'uc:bindable': false,
    methods: [
        {
            id: 'fetchJob',
            title: $t('k_45f7c739'),
            arguments: [{ id: 'jobId', type: 'string', description: $t('k_21767e56') }],
        },
        {
            id: 'approval',
            title: $t('k_2615b7b0'),
            arguments: [
                { id: 'jobId', type: 'string', description: $t('k_21767e56') },
                { id: 'nodeId', type: 'string', description: $t('k_39090a8c') },
                {
                    id: 'operation', type: 'string', description: $t('k_c0f02b6d'), enum: ApprovalOperation,
                },
                { id: 'comment', type: 'string', description: $t('k_68a001fc') },
                { id: 'form', type: 'object', description: $t('k_dd04887b') }
            ],
        },
        {
            id: 'cancelApproval',
            title: $t('k_4aacd7d'),
            arguments: [
                { id: 'jobId', type: 'string', description: $t('k_21767e56') },
                { id: 'nodeId', type: 'string', description: $t('k_39090a8c') },
                { id: 'comment', type: 'string', description: $t('k_88a26373') },
            ],
        },
        {
            id: 'startFlow',
            title: $t('k_238054ac'),
            arguments: [
                { id: 'flowId', type: 'string', description: $t('k_21767e56') },
                { id: 'params', type: 'object', description: $t('k_77728eba') },
            ],
        },
        {
            id: 'fetchFlow',
            title: $t('k_ca7cb56f'),
            arguments: [{ id: 'flowId', type: 'string', description: $t('k_21767e56') }],
        },
        {
            id: 'fetchApprovalNodeInfo',
            title: $t('k_5275db4c'),
            arguments: [
                { id: 'jobId', type: 'string', description: $t('k_21767e56') },
                { id: 'nodeId', type: 'string', description: $t('k_39090a8c') }
            ],
        },
        {
            id: 'fetchLogNodeInfo',
            title: $t('k_f83449ef'),
            arguments: [
                { id: 'jobId', type: 'string', description: $t('k_21767e56') },
                { id: 'nodeId', type: 'string', description: $t('k_39090a8c') }
            ],
        },
        {
            id: 'fetchJobList',
            title: $t('k_bf1ff4b5'),
            arguments: [
                { id: 'title', title: $t('k_8bdba086'), type: 'string', description: $t('k_434040f9') },
                { id: 'creator', title: $t('k_66ca76fd'), type: 'string', description: $t('k_f4117f5e') }
            ],
        },
        {
            id: 'fetchJobListByType',
            title: $t('k_3b2b7508'),
            description: $t('k_e0d36f63'),
            arguments: [
                { id: 'title', title: $t('k_8bdba086'), type: 'string', description: $t('k_434040f9') },
                {
                    id: 'type', title: $t('k_eb51ec65'), type: 'string', description: $t('k_eb51ec65'), enum: [{
                            label: $t('k_9c641f62'),
                            value: 'created',
                        }, {
                            label: $t('k_1eee3da2'),
                            value: 'participated',
                        },
                        {
                            label: $t('k_79cc91b7'),
                            value: 'related',
                        },
                        {
                            label: $t('k_ba735eb9'),
                            value: 'pending',
                        }],
                }
            ],
        },
    ],
});
export default getFlowSchema;
